import React from "react";
import { AuthPaymentContainer } from "../misc/auth-payment-container.component";
import { generateLoanDescription } from "../misc/messaging-utils";
import { AuthRestartButton } from "../misc/restart-button.component";
import { ReviewDisplayField } from "../misc/review-display-field.component";
import Show from "../../../utils/show.component";
import moment from "moment";
import { usd } from "../../../utils/utils";

export const AuthSkipSummary = (props) => {
  const skipDebitResponse = props.authPayment.skipDebitResponse;
  const skipPostResponse = props.authPayment.skipPostResponse;

  const formValues = props.thisForm && props.thisForm.values;
  const skipPaymentMethod = formValues && formValues.skipPaymentMethod;

  const showAdditionalAmountFields =
    skipPaymentMethod === "Debit Card" && skipPostResponse.AdditionalAmount;

  const subtitle = `Your skip-a-pay has been successfully submitted. A confirmation email has been sent to email address: ${props.authPayment.memberInfo.email}`;

  const formatSkipDates = () => {
    const formatted = skipPostResponse.SkippedPaymentDates.map((dateString) => {
      const date = moment(dateString).format("MM/DD/YYYY");
      return date;
    });

    return formatted;
  };

  const formattedSkipDates = formatSkipDates();

  const useSmallerText = skipPostResponse.PaymentAccountInfo.includes("Account");
  const accountTextModifier = useSmallerText ? "f14" : "";

  return (
    <AuthPaymentContainer title={"Payment Summary"} subtitle={subtitle}>
      <div className="bold f20 text-centered">
        {`${generateLoanDescription(props.selectedLoan, true)}`}
      </div>
      <div className="my-4 divider"></div>
      <div>
        <ReviewDisplayField title={"Payment(s) To Skip"} value={formattedSkipDates[0]} />
        <Show condition={formattedSkipDates.length > 1}>
          <ReviewDisplayField title={""} value={formattedSkipDates[1]} />
        </Show>
        <ReviewDisplayField
          title={"Payment Account"}
          value={skipPostResponse.PaymentAccountInfo.replace("Account e", "E")}
          valueClassNames={`minwidth-fit ${accountTextModifier}`}
          titleColumnSize={"col-md-6"}
          valueColumnSize={"col-md-6"}
        />
        <Show condition={showAdditionalAmountFields}>
          <ReviewDisplayField
            title={"Fee Amount"}
            value={usd.format(skipPostResponse.FeeAmount)}
            valueClassNames={"minwidth-fit"}
          />
          <ReviewDisplayField
            title={"Negative Balance Due"}
            value={usd.format(skipPostResponse.AdditionalAmount)}
            valueClassNames={"minwidth-fit"}
          />
        </Show>
        <ReviewDisplayField
          title={"Total Fee Amount"}
          value={usd.format(skipPostResponse.TotalAmount)}
        />
        <ReviewDisplayField
          title={"Next Due Date"}
          value={moment(skipPostResponse.NextDueDate).format("MM/DD/YYYY")}
        />
      </div>
      <AuthRestartButton backToLoans={props.backToLoans} bgColor={"#00558c"} />
    </AuthPaymentContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/summary/auth-skip-summary.component.js